module.exports = __webpack_public_path__ + "img/bg_function06_4_m.47b128a9.svg";